enum StatusTypes {
    Order = 'order',
    Invoice = 'notification',
    Paylink = 'paylink',
    HTTP = 'http',
}

export default StatusTypes;
